import { get, post, del, put } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf';
import session from 'lib/session';
import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { takeEvery, put as putEffect } from 'redux-saga/effects';
import { identity } from 'lodash';

export const actions = {
  fetch: get`page-redirects/${session.getMerchant}/`(),
  create: post`page-redirects/${session.getMerchant}`(identity),
  remove: del`page-redirects/${session.getMerchant}/:id`(identity),
  update: put`page-redirects/${session.getMerchant}/:id`(identity),
};


export const reducer = createReducer([actions.fetch], {
  [actions.create]: (s, { payload }) => 
    ({ entities: [payload, ...s.entities] }),
  [actions.update]: (s, { payload }) => 
    ({ entities: s.entities.map(i =>
      i.id !== payload.id && i || payload
    )}),
  [actions.remove]: (s, { meta }) => 
    ({ entities: s.entities.filter((i) => i.id !== meta.id )})
});

